import { render, staticRenderFns } from "./InventoryOverview.vue?vue&type=template&id=7fcafd16&scoped=true"
import script from "./InventoryOverview.vue?vue&type=script&lang=js"
export * from "./InventoryOverview.vue?vue&type=script&lang=js"
import style0 from "./InventoryOverview.vue?vue&type=style&index=0&id=7fcafd16&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fcafd16",
  null
  
)

export default component.exports